import axios from 'axios'

// 创建 axios 实例
const request = axios.create({
  // API 请求的默认前缀
  baseURL: process.env.VUE_APP_SERVER_URL,
  timeout: 0, // 请求超时时间
})

// 异常拦截处理器
const errorHandler = (error) => {
  return Promise.reject(error)
}

// 获取哈希模式路由地址参数
export function getHashSearchParam(key) {
  if (key in getHashSearchParam.cache && getHashSearchParam.cache.key) {
    return getHashSearchParam.cache.key
  }
  const url = location.href
  const hash = url.substring(url.indexOf("#") + 1)
  const searchIndex = hash.indexOf("?")
  const search = searchIndex !== -1 ? hash.substring(searchIndex + 1) : ""
  const usp = new URLSearchParams(search)
  const result = usp.get(key)
  getHashSearchParam.cache.key = result
  return result
}
getHashSearchParam.cache = {}

// request interceptor
request.interceptors.request.use((config) => {
  config.headers.Authorization = 'Bearer ' + getHashSearchParam('Authorization')
  return config
}, errorHandler)

// response interceptor
request.interceptors.response.use((response) => {
  if (response.data && response.data.code === 200) {
    return response.data
  } else if (response.data instanceof Blob) {
    return response.data
  }
  return Promise.reject(response)
}, errorHandler)

export default request
